export const componentFakeAnimation = 1;
export const componentFakePagerDuplicate = 2;
